import React, { useState } from 'react';
import { Popover } from '@jjj/components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import startCase from 'lodash/startCase';
import { LockIcon } from '@jjj/move';
import { DropdownWrapper, PopoverIconWrapper, LockedIcon, PopoverWrapper } from './cells.style';
import { hoverOverRowActionsGAEvent } from '../../helpers/googleAnalytics/events';
import { TextCell } from './helperCells';
import { t } from '../../i18n';

export function getActionsPopoverContent(actionsList, closePopoverCb) {
  return (
    <DropdownWrapper className="isoDropdown">
      <div className="popover-buttons-container">
        {actionsList.map(({ locked, danger, key, name, onActionClick, options }) => {
          const isLocked = locked || options?.locked;

          const content = (
            <>
              <span className="actionName">{name || startCase(key.replace(/_/g, ' '))}</span>
              {isLocked && (
                <LockedIcon>
                  <LockIcon />
                </LockedIcon>
              )}
            </>
          );

          return typeof onActionClick === 'string' ? (
            <Link
              onClick={event => {
                closePopoverCb();
                event.stopPropagation();
              }}
              to={onActionClick}
              disabled={isLocked}
              className={danger ? 'danger' : undefined}
              key={name || key}
              data-cy="table_action_popover_content-link"
            >
              {content}
            </Link>
          ) : (
            <button
              disabled={isLocked}
              className={danger ? 'danger' : undefined}
              key={name || key}
              onClick={event => {
                closePopoverCb();
                event.stopPropagation();
                onActionClick();
              }}
              type="button"
              data-cy="table-action-button"
            >
              {content}
            </button>
          );
        })}
      </div>
    </DropdownWrapper>
  );
}

export const ActionsPopover = ({ actionsList, popoverProps, analyticsEventName }) => {
  const [open, setOpen] = useState(false);
  const closePopover = () => setOpen(false);
  const handleOpenChange = newOpen => {
    if (newOpen && analyticsEventName) {
      hoverOverRowActionsGAEvent(analyticsEventName);
    }

    setOpen(newOpen);
  };

  return (
    <PopoverWrapper $height={popoverProps?.height}>
      <Popover
        classNames={{ root: 'actions-item-popover' }}
        arrow={{ pointAtCenter: true }}
        content={getActionsPopoverContent(actionsList, closePopover)}
        onClick={event => event.stopPropagation()}
        placement="bottomRight"
        popupAlign={{ offset: [27, -20] }}
        trigger="hover"
        open={open}
        onOpenChange={handleOpenChange}
        {...popoverProps}
      >
        <PopoverIconWrapper>
          <FontAwesomeIcon icon="ellipsis-h" />
        </PopoverIconWrapper>
      </Popover>
    </PopoverWrapper>
  );
};

export const getActionColumn = (
  getActions,
  columnProps = {},
  popoverProps = {},
  hidden = false,
  analyticsEventName = '',
  allowEmptyActions = false,
) => {
  return {
    title: '        ',
    key: 'actions',
    width: '54px',
    fixed: 'right',
    sorter: false,
    render: object => {
      if (hidden || !object || ((!object.actions || !object.actions.length) && !allowEmptyActions)) {
        return null;
      }

      const actionsList = getActions(object);

      if (!actionsList || !actionsList.length) {
        return null;
      }

      return (
        <ActionsPopover actionsList={actionsList} popoverProps={popoverProps} analyticsEventName={analyticsEventName} />
      );
    },
    ...columnProps,
  };
};

export const getLegalEntityColumn = (columnProps = {}) => {
  return {
    title: t('dash.common.legal_entity.label'),
    key: 'legal_entity',
    sorter: false,
    render: (object, url) => TextCell(object.legal_entity?.name || '', url),
    ...columnProps,
  };
};
